<template>
	<div class="bg">
        <!-- 顶部导航 -->
		<common-head :active="0" ></common-head>

		<!-- 轮播图信息 -->
		<common-slide ></common-slide>

		<!-- 底部信息 -->
		<common-footer></common-footer>

	</div>
</template>

<script>
	import commonHead from '@/components/wap/commonHead.vue';
	import commonSlide from '@/components/wap/commonSlide.vue';
    import commonFooter from '@/components/wap/commonFooter.vue';
	export default {
		name: 'index',
		components: {
			commonHead,commonSlide,commonFooter
		},
		data() {
			return {
				
			}
		},
		metaInfo() {
			return {
				title: '首页-' + this.config.site.name,
				meta: [
					{ name: "keywords", content: "" },
					{ name: "description", content: "" },
					{ name: 'viewport', content:'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'}
				],
			}
		},
	}
</script>
<style scoped lang="less">
	.bg{
		background-color: #f2f2f2;
	}
</style>